
import { Component, OnInit } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from '@angular/router';
import { DecryptService } from '../core/services/decrypt.service';
import { Globals } from '../core/global';
import { LoginService } from '../core/services/login.service';
import { GameService } from '../core/services/game.service';
import { EventsService } from '../core/services/events.service';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss']
})

export class SplashComponent implements OnInit {

  correlatorId: any;
  token: any;
  statusCode: any;

  constructor(
    public router: Router,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private decrypt: DecryptService,
    private global: Globals,
    private loginService: LoginService,
    private gameService: GameService,
    private events: EventsService
  ) { }

  ngOnInit() {
    this.events.eventStart({ eventType: 'LANDING_PAGE_ACCESS', triggerType: 'access' });

    this.loginService.getHe().subscribe(params => {
      
      if(params['msisdn']) {
        this.gameService.mainLoader.next(true);
        console.log(params['msisdn']);

         //lets decrypt it
          this.decrypt.decrypt(params['msisdn']).subscribe(response => {
            console.log(response);
            
            this.loginService.validatePin(response['responseData']['result'], null, true).subscribe(val => {
              this.gameService.mainLoader.next(false);

              localStorage.setItem('msisdn', btoa(JSON.stringify(response['msisdn'])));
              // localStorage.setItem('token', val["responseData"].token);
              // localStorage.setItem('apitoken', this.token);
              // this.router.navigate(['/onboarding']);
            })
          })

      }
    })

    // this.route.queryParams.subscribe(params => {

    //   this.correlatorId = params['correlatorId'];
    //   this.token = params['token'];
    //   this.statusCode = params['statusCode'];

    //   if (this.correlatorId && this.token && this.statusCode) {

    //     //its HE
    //     //Lets check it
    //     if (this.statusCode == '1') {

    //       this.gameService.mainLoader.next(true);

    //       //lets decrypt it
    //       this.decrypt.doDecrypt(this.token).subscribe(response => {
    //         this.loginService.validatePin(response['msisdn'], null, true).subscribe(val => {
    //           this.gameService.mainLoader.next(false);

    //           localStorage.setItem('msisdn', btoa(JSON.stringify(response['msisdn'])));
    //           localStorage.setItem('token', val["responseData"].token);
    //           localStorage.setItem('apitoken', this.token);
    //           // this.router.navigate(['/onboarding']);
    //         })
    //       })
    //     }
    //   } else {
    //     //check localstorage
    //     if (!localStorage.getItem('apitoken') && !localStorage.getItem('msisdn')) {
    //       this.gameService.mainLoader.next(true);
    //       window.location.href = `http://www.digitalauthentication.om/api.php?action=he&correlatorId=${this.global.generateTXID()}&roleId=${this.global.roleId}&redirectURL=http://oman-oo-gigaplay.com/`;
    //     }
    //   }

    // });
  }

  ngAfterViewInit() {
    this.events.eventStart({ eventType: 'LANDING_PAGE_LOADED', triggerType: 'access' });
  }

  startFlow(language) {
    this.translate.use(language);
    // set language
    localStorage.setItem('lang', language);

    this.router.navigate(['/onboarding']);

  }
}
